import { EMPLOYEE_VERTICAL } from '../resources/endPoint';
import { serviceName } from '../resources/serviceConstants';

const employeeVertical = (method, url, payload) => ({
  url,
  method,
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  ...(payload ? { payload } : {}),
  service: serviceName.MASTER_MS,
});

export const getEmployeeVertical = () => employeeVertical(
  'get',
  `${EMPLOYEE_VERTICAL}?cb=${Date.now()}`,
);

export const createEmployeeVertical = (employeeVerticalName, isUtilized) => employeeVertical(
  'post',
  EMPLOYEE_VERTICAL,
  {
    employeeVerticalName: employeeVerticalName,
    enabledForUtilization: isUtilized,
  },
);

export const updateEmployeeVertical = (
  employeeVerticalId,
  employeeVerticalName,
  isUtilized,
  isActive,
) => employeeVertical(
  'put',
  `${EMPLOYEE_VERTICAL}/${employeeVerticalId}`,
  {
    employeeVerticalName: employeeVerticalName,
    enabledForUtilization: isUtilized,
    isActive: isActive,
  },
);
